import { type Enum } from '@webapp/infrastructure/types/Enum'
import { type OrderApprovalTab } from '@webapp/modules/purchasing/entities/enums/OrderApprovalTabEnum'

export const AccountCodeCorrectionTabs = {
  ORDERS: 'orders',
  ORDERS_AUDIT_LOG: 'orders-audit-log',
  EXPENSES: 'expenses',
  EXPENSES_AUDIT_LOG: 'expenses-audit-log',
} as const
export type AccountCodeCorrectionTab = Enum<typeof AccountCodeCorrectionTabs>
export interface IAccountCodeCorrectionPageParams {
  tab: AccountCodeCorrectionTab
}

export const OrderStatusPageStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
  PURCHASED: 'purchased',
  RECEIVED: 'received',
} as const
export type OrderStatusPageStatus = Enum<typeof OrderStatusPageStatuses>

export const OrderDetailsPageReferrers = {
  ORDER_STATUS: 'order_status',
  ORDER_APPROVAL: 'order_approval',
  PROCUREMENT: 'create_purchase_order',
  PURCHASE_ORDER_LIST: 'purchase_orders',
  PURCHASE_ORDER_DETAILS: 'purchase_order_details',
  RECEIVE_LIST: 'receive_purchase_order_list',
  RECEIVE_DETAILS: 'receive_purchase_order_details',
} as const
export type OrderDetailsPageReferrer = Enum<typeof OrderDetailsPageReferrers>
export const OrderDetailsPageSearchParams = {
  REFERRER: 'referrer',
} as const
export const OrderDetailsPageTabs = {
  DETAILS: 'details',
  STATUS: 'status',
  AUDIT_LOG: 'logs',
} as const
export type OrderDetailsPageTab = Enum<typeof OrderDetailsPageTabs>
export interface OrderDetailsPageParams {
  uuid: uuid
  tab?: OrderDetailsPageTab
}

// Deliberately its own list, not derived from OrderApprovalTabs: this is the
// AngularJS route's contract, which retires with
// PUR_4521_ORDER_APPROVAL_STATUS_POLISH and is free to diverge until then.
export const LegacyOrderApprovalsPageStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
} as const
export type LegacyOrderApprovalsPageStatus = Enum<
  typeof LegacyOrderApprovalsPageStatuses
>

export interface LegacyOrderApprovalsPageParams {
  status: LegacyOrderApprovalsPageStatus
}

export interface IOrderApprovalsPageParams {
  status: OrderApprovalTab
}

export const PurchaseOrderListPageStatuses = {
  ALL: 'all',
  OPEN: 'open',
  PARTIAL: 'partial',
  CLOSED: 'closed',
  CANCELLED: 'cancelled',
  PAID: 'paid',
} as const
export type PurchaseOrderListPageStatus = Enum<
  typeof PurchaseOrderListPageStatuses
>

export const ReceiveListPageStatuses = {
  OPEN: 'open',
  PARTIAL: 'partial',
  CLOSED: 'closed',
  CANCELLED: 'cancelled',
  PAID: 'paid',
  ALL: 'all',
} as const
export type ReceiveListPageStatus = Enum<typeof ReceiveListPageStatuses>
